/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable react/require-default-props */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import mbpLogger from 'mbp-logger';
import {
    object, shape, arrayOf, string, array,
} from 'prop-types';
import { determineLanguagePrefixPath } from '../../../../../../../helpers/determineInternationalizationPath';
// components
import GiftBlockBanner from './Partials/GiftBlockBanner';
import GiftBlockHeader from './Partials/GiftBlockHeader';
import GiftBlockBottom from './Partials/GiftBlockBottom';

const styles = (theme) => ({
    bannerContainer: {
        width: '75%',
        margin: 'auto',
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    bottomContainer: {
        width: '60%',
        margin: 'auto',
        paddingBottom: '25px',
    },
});
/* eslint-disable react/prop-types */ // TODO refactor as part of PWA-2848, render f(x) pattern doesnt like proptypes
const DesktopGiftBlock = ({ classes, block }) => {
    const key = Object.keys(block)[0];
    const renderHeader = () => {
        const header = block?.header || {};
        const url = header.icon?.url || '';
        const title = header.icon?.title || '';
        const copy = header.copy || '';
        if (!url || !title || !copy) {
            mbpLogger.logDebug({
                message: `No url, title, or copy returned for Desktop Gift Block Headers block \n url data ${url} \n title data ${title} \n copy data ${copy}`,
                module: 'mbp-pwa-ui',
            });
            return null;
        }
        return <GiftBlockHeader url={url} title={title} copy={copy} />;
    };

    const renderBanners = () => {
        const { banners: { banner = [] } = {} } = block;
        // TODO PWA-2848 comes with mobile & desktop, should convert query to using viewport to avoid
        const [banner_group = ''] = banner ? banner.filter((viewport) => viewport.name === 'Desktop Banner') : [];
        const bannerAcross = banner_group?.banners_across;
        if (!banner_group) {
            mbpLogger.logDebug({
                message: `No banner_group returned for Desktop Gift Block Banners block \n banner_group data ${banner_group}`,
                module: 'mbp-pwa-ui',
            });
            return null;
        }
        return (
            <div className={classes.bannerContainer}>
                <Grid container>
                    {banner_group?.banner_group?.map((group) => {
                        const { link: { title = '', href = ''  } = '', image: { url = '' } = ''  } = group;
                        if (!title || !href || !url) {
                            return null;
                        }
                        return <GiftBlockBanner key={`${title}`} title={title} link={determineLanguagePrefixPath(href)} imgUrl={url} imgTitle={title} bannerAcross={bannerAcross} />;
                    })}
                </Grid>
            </div>
        );
    };

    const renderBottom = () => {
        const { bottom: { bottom_banner = [] } = {} } = block;
        const { image = '' } = bottom_banner?.[0] || {};
        if (!image) {
            mbpLogger.logDebug({
                message: `No bottom_banner returned for Desktop Gift Block Bottom block \n image data ${image}`,
                module: 'mbp-pwa-ui',
            });
            return null;
        }
        return (
            <div className={classes.bottomContainer}>
                <Grid container>
                    <GiftBlockBottom image={image} />
                </Grid>
            </div>
        );
    };

    switch (key) {
        case 'header':
            return renderHeader();

        case 'banners':
            return renderBanners();

        case 'bottom':
            return renderBottom();

        default:
            mbpLogger.logError({
                message: `Unrecognized page_block for Template Collection Sem Page Desktop Gift Block. \n Please remove from ContentStack \n Block name key = ${key}, Block Data = ${block}`,
                module: 'mbp-pwa-ui',
            });
            return null;
    }
};

DesktopGiftBlock.propTypes = {
    classes: object.isRequired,
    block: shape({
        header: shape({
            copy: string,
        }),
        banners: shape({
            banner: arrayOf(shape({
                banner_group: array,
            })),
        }),
        bottom: shape({
            bottom_banner: arrayOf(shape({
                image: object,
            })),
        }),
    }).isRequired,
};

export default withStyles(styles)(DesktopGiftBlock);
